var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowUpDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Outline Arrow Up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Icon \xD0\xA1olor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14292 3.57699L14.1258 7.7222C14.6104 8.12611 15.3315 8.05993 15.735 7.57615C16.1395 7.09123 16.0732 6.37241 15.5887 5.96964L8.73148 0.264709C8.67777 0.22021 8.61491 0.197391 8.55548 0.164302C8.50748 0.136918 8.46634 0.10383 8.41377 0.083292C8.28234 0.0319476 8.14405 0.00114099 8.00462 0.00114099C8.00348 0.00114099 8.00119 0 8.00005 0C7.99891 0 7.99662 0.00114099 7.99548 0.00114099C7.85605 0.00114099 7.71776 0.0319476 7.58633 0.083292C7.53376 0.10383 7.49262 0.136918 7.44462 0.164302C7.38519 0.197391 7.32233 0.22021 7.26862 0.264709L0.41143 5.96964C0.140572 6.19556 0 6.5196 0 6.84592C0 7.10378 0.0868568 7.36279 0.265144 7.57615C0.668575 8.05993 1.38972 8.12611 1.8743 7.7222L6.85719 3.57699L6.85719 14.859C6.85719 15.4888 7.36919 16 8.00005 16C8.63091 16 9.14292 15.4888 9.14292 14.859L9.14292 3.57699Z",
    fill: "#929596"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowUpDisabled);
export default __webpack_public_path__ + "static/media/icon-arrow-up-disabled.077d186db4312415b318f3dc07d0e2cc.svg";
export { ForwardRef as ReactComponent };